var generic = generic || {};
var presentAfterpay = presentAfterpay || {};
var presentClearpay = presentClearpay || {};
var installmentsConfig = installmentsConfig || {};
var installmentConfig = Drupal.settings.installment_price;

(function ($) {
  Drupal.behaviors.afterPayInit = {
    locale: '',
    library: installmentConfig?.lib,
    priceSelector: '.js-price_installment',
    installmentsType: '',

    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.setup(context);
    },

    setup: function (context) {
      var self = this;
      var lib = installmentConfig && installmentConfig.lib;

      // This file lives in bb_base, so it loads on every market, including
      // the ones with no installment provider. Read the library here and
      // stop when it is absent: self.library is captured when the file
      // parses, and assigning undefined to script.src appends
      // <script src="undefined">, which the browser resolves against the
      // origin and requests as /undefined.
      if (!lib) {
        return;
      }

      self.library = lib;
      self.locale = installmentConfig.locale || generic.cookie('LOCALE');
      var imported = document.createElement('script');
      var hasAfterPay = $('.js-afterpay', context).length > 0;

      // Compare against lib rather than installmentConfig?.lib. Optional
      // chaining short-circuits the whole chain, so when the config is
      // missing the comparison yields undefined !== -1, which is true, and
      // the market is wrongly tagged as afterpay.
      if (lib.indexOf('present-afterpay') !== -1) {
        self.installmentsType = 'afterpay';
      } else if (lib.indexOf('present-clearpay') !== -1) {
        self.installmentsType = 'clearpay';
      }

      imported.src = lib;
      document.head.appendChild(imported);
      if (!imported.readyState && hasAfterPay) {
        imported.onload = function () {
          self.initInstallments(context);
        };
      }
    },

    instalmentFunc: function (amount) {
      var self = this;
      var currency = window.utag_data ? window.utag_data.currency_code : installmentConfig.currency;

      installmentsConfig = {
        priceSelector: self.priceSelector,
        locale: self.locale,
        currency: currency,
        showUpperLimit: true,
        amount: amount,
        minMaxThreshold: {
          min: installmentConfig.min_value,
          max: installmentConfig.max_value
        }
      };
      if (installmentConfig.open_icon) {
        installmentsConfig['replaceModalOpenIcon'] = installmentConfig.open_icon;
      }
      if (self.installmentsType === 'afterpay') {
        if (installmentConfig.logo_color) {
          installmentsConfig['afterpayLogoColor'] = installmentConfig.logo_color;
        }
        if (installmentConfig.use_width) {
          installmentsConfig['useWith'] = installmentConfig.use_width;
        }
        if (installmentConfig.text_type) {
          installmentsConfig['textType'] = installmentConfig.text_type;
        }
        if (typeof presentAfterpay === 'function') {
          new presentAfterpay(installmentsConfig).init();
        }
      }
      if (self.installmentsType === 'clearpay') {
        installmentsConfig.showUpperLimit = false;
        if (installmentConfig.logo_color) {
          installmentsConfig['clearpayLogoColor'] = installmentConfig.logo_color;
        }
        new presentClearpay(installmentsConfig).init();
      }
    },
    initInstallments: function (context) {
      var self = this;
      var amount = null;
      var $productData = $('.js-product-full-data, .js-product-starter-kit-data', context);
      var $productPrice = $('.js-product-price', $productData);
      var $skuPrice = $('.js-sku-price', $productPrice);

      if (self.installmentsType === 'afterpay') {
        presentAfterpay.afterpayConfig = function(ammount) {
          self.instalmentFunc(ammount);
        }
      } else if (self.installmentsType === 'clearpay') {
        presentClearpay.clearpayConfig = function(ammount) {
          self.instalmentFunc(ammount);
        }
      }

      if ($skuPrice.length > 0) {
        amount = $skuPrice.html().replace(/[^\d]/g, '');
      }
      if (amount !== null) {
        if (self.installmentsType === 'afterpay') {
          presentAfterpay.afterpayConfig(amount);
        } else if (self.installmentsType === 'clearpay') {
          presentClearpay.clearpayConfig(amount);
        }
      }
      $(document).trigger('installments-lib-ready');
    },

    attached: false
  };
})(jQuery);
